import distanceToPoint from './distanceToPoint';

export { distanceToPoint };
